import { Anchor } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';
import { useEffect, useRef } from 'react';

import { Block } from '../../../../components/Block';
import type { BlockDataProps } from '../../../../components/Block/query';
import { hiddenCss } from './ArDownloadFormBlock.styles';
import { successBlockCss, successLogoCss } from './ArDownloadSuccess.styles';

interface ArDownloadSuccessProps {
  successBlock: BlockDataProps;
  downloadUrl: string | undefined;
  logoImageSource?: string;
  logoAltText?: string;
}

export const ArDownloadSuccess: FC<ArDownloadSuccessProps> = ({
  successBlock,
  downloadUrl,
  logoImageSource,
  logoAltText,
}) => {
  const anchorTag = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (downloadUrl && anchorTag.current) {
      anchorTag.current.click();
    }
  }, [downloadUrl]);

  return (
    <>
      <Anchor
        data-testid="test-anchor-download"
        ref={anchorTag}
        href={downloadUrl}
        download
        className={hiddenCss}
      >
        Hidden download link
      </Anchor>
      {successBlock && (
        <Block
          {...successBlock}
          className={successBlockCss}
          preChildren={
            logoImageSource ? (
              <img className={successLogoCss} src={logoImageSource} alt={logoAltText} />
            ) : undefined
          }
        />
      )}
    </>
  );
};
